import {
    Box,
    Button,
    Heading,
    HStack,
    Input,
    InputGroup,
    InputLeftElement,
    Switch,
    Text,
    VStack,
    Flex,
} from '@chakra-ui/react';
import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import DeliveryModal from '../components/Dashboard/DeliveryModal';
import { OrderSection } from './dashboard/components/DashboardStyles';
import { backbtn, location, search, userIcon } from './dashboard/components/Icons';

import { useSelector, useDispatch } from 'react-redux';
import { add_shipping_details } from '../redux/actions/productActions';
import { Backbutton } from 'components/LandingPageComponents/styles/HeaderStyles';
import useGetUserDetails from 'hooks/useGetUserDetail';

const Delivery = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [checked, setChecked] = useState(false);
    const productReducer = useSelector((state) => state.productReducer);
    const { quoteId, cartItems } = productReducer;
    const closeModal = () => setIsModalOpen(false);
    const openModal = () => setIsModalOpen(true);

    const dispatch = useDispatch();

    const total = cartItems?.items.reduce((a, b) => a + Number(b.price * b.qty), 0);

    const [address, setAddress] = useState({ street: '' });
    const [userInfo, setUserInfo] = useState({ name: '', phone: '' });

    const shippingAddress = {
        addressInformation: {
            shippingAddress: {
                region: 'Fazsion Warehouse',
                region_id: 647,
                country_id: 'NG',
                street: [''],
                company: 'abc',
                telephone: '',
                postcode: '1001',
                city: 'LAGOS',
                firstname: '',
                lastname: '',
                email: '',
                prefix: 'address',
                region_code: 'Fazsion Warehouse',
                sameAsBilling: 1,
            },
            billingAddress: {
                region: 'Fazsion Warehouse',
                region_id: 647,
                country_id: 'NG',
                street: ['10 Sam Adebgite'],
                company: 'abc',
                telephone: '',
                postcode: '10001',
                city: 'Lagos',
                firstname: '',
                lastname: '',
                email: '',
                prefix: 'address',
                region_code: 'Fazsion Warehouse',
            },
            shipping_method_code: 'bestway',
            shipping_carrier_code: 'tablerate',
            extension_attributes: {},
        },
        quoteId,
    };

    const user = useGetUserDetails();
    var decoded = user?.flattenedUser;

    let data = useMemo(() => {
        return {
            addressInformation: {
                shippingAddress: {
                    region: 'Fazsion Warehouse',
                    region_id: 647,
                    country_id: 'NG',
                    street: [],
                    company: 'abc',
                    telephone: '',
                    postcode: '10001',
                    city: 'Lagos',
                    firstname: '',
                    lastname: '',
                    email: user?.email,
                    prefix: 'address',
                    region_code: 'Fazsion Warehouse',
                    sameAsBilling: 1,
                },
                shipping_method_code: 'bestway',
                shipping_carrier_code: 'tablerate',
                extension_attributes: {},
            },
            quoteId,
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quoteId, decoded?.email]);

    const add = data?.addressInformation?.shippingAddress;
    const handleLocationChange = (e) => {
        setAddress((add) => {
            return {
                ...add,
                street: e.target.value,
                city: e.target.value ? 'LAGOS' : '',
                company: e.target.value ? 'Nigeria' : '',
                postalcode: e.target.value ? '10001' : '',
            };
        });
        add.street[0] = address.street;
    };
    const handleNameChange = (e) => {
        setUserInfo((info) => ({
            ...info,
            [e.target.name]: e.target.value,
        }));
        add[e.target.name] = userInfo[e.target.name];
    };
    const handlePhoneChange = (e) => {
        // add.telephone = e.target.value;
        setUserInfo((info) => ({
            ...info,
            phone: e.target.value,
        }));
        add.telephone = userInfo.phone;
    };
    const handleChange = (e) => {
        e.preventDefault();
        setChecked(!checked);

        add.street[0] = address?.street || '77 Opebi Rd, Opebi 101233, Ikeja';
        add.city = 'LAGOS';
        add.company = address.company;
        add.postalcode = address.postalcode;
        add.email = decoded?.email;
    };
    const addLocationInfo = (e) => {
        setAddress((info) => ({
            ...info,
            street: e.target.value,
        }));
        add.street[0] = address.street;
        add.city = address.city;
        add.company = address.company;
        add.postalcode = address.postalcode;
        if (e.key === 'Enter') {
            add.street[0] = address.street;
            add.city = address.city;
            add.company = address.company;
            add.postalcode = address.postalcode;
        }
        setAddress({});
    };

    const addNameInfo = (e) => {
        setUserInfo((info) => ({
            ...info,
            [e.target.name]: e.target.value,
        }));
        if (userInfo) {
            add.firstname = userInfo.firstname;
            add.lastname = userInfo.lastname;
            if (e.key === 'Enter') {
                add.firstname = userInfo.firstname;
                add.lastname = userInfo.lastname;
            }
        }
    };

    const addPhoneInfo = (e) => {
        setUserInfo((info) => ({
            ...info,
            phone: e.target.value,
        }));
        add.telephone = userInfo.phone;
        if (e.key === 'Enter') {
            add.telephone = userInfo.phone;
        }
    };

    const setOrderDetails = () => {
        shippingAddress.addressInformation.shippingAddress.street = add?.street;
        shippingAddress.addressInformation.shippingAddress.telephone = add?.telephone;
        shippingAddress.addressInformation.shippingAddress.firstname = add?.firstname;
        shippingAddress.addressInformation.shippingAddress.lastname = add?.lastname;
        shippingAddress.addressInformation.shippingAddress.email = add?.email;

        shippingAddress.addressInformation.billingAddress.street = add?.street;
        shippingAddress.addressInformation.billingAddress.telephone = add?.telephone;
        shippingAddress.addressInformation.billingAddress.firstname = add?.firstname;
        shippingAddress.addressInformation.billingAddress.lastname = add?.firstname;
        shippingAddress.addressInformation.billingAddress.email = add?.email;

        dispatch(add_shipping_details(shippingAddress));
    };
    return (
        <OrderSection>
            <HStack
                justify="space-between"
                alignItems="center"
                display={{ base: 'flex', lg: 'none', sm: 'flex' }}
                mt="27px"
                w="90vw"
                mx="auto">
                <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
                <div className="menuSection"></div>
                <div></div>
            </HStack>
            <Box
                w={{ base: '90vw', lg: '50%' }}
                mx={{ base: 'auto', lg: '0' }}
                h="80vh"
                bg={{ base: 'none', lg: 'white' }}
                p={{ base: '0', lg: '15px 30px' }}
                boxShadow={{ base: 'none', lg: '0px 4px 33px rgba(0, 0, 0, 0.03)' }}
                position="relative">
                <Heading
                    color="#090A0A"
                    w="80%"
                    lineHeight="36px"
                    fontSize="32px"
                    mt="20px"
                    mb="15px">
                    First Name
                </Heading>

                <InputGroup
                    overflow="hidden"
                    bg="white"
                    border="2px solid #1b3b5f"
                    borderRadius="8px"
                    h="48px"
                    mt="15px">
                    <InputLeftElement pointerEvents="none">{search}</InputLeftElement>
                    <Input
                        type="text"
                        placeholder="type firstname"
                        h="full"
                        name="firstname"
                        inputMode="search"
                        border="none"
                        value={userInfo.firstname}
                        onChange={(e) => handleNameChange(e)}
                        onKeyUp={(e) => addNameInfo(e)}
                    />
                </InputGroup>
                <Heading
                    color="#090A0A"
                    w="80%"
                    lineHeight="36px"
                    fontSize="32px"
                    mt="20px"
                    mb="15px">
                    Last Name
                </Heading>

                <InputGroup
                    overflow="hidden"
                    bg="white"
                    border="2px solid #1b3b5f"
                    borderRadius="8px"
                    h="48px"
                    mt="15px">
                    <InputLeftElement pointerEvents="none">{search}</InputLeftElement>
                    <Input
                        type="text"
                        placeholder="type lastname"
                        h="full"
                        name="lastname"
                        inputMode="search"
                        border="none"
                        value={userInfo.lastname}
                        onChange={(e) => handleNameChange(e)}
                        onKeyUp={(e) => addNameInfo(e)}
                    />
                </InputGroup>

                <Heading
                    color="#090A0A"
                    w="80%"
                    lineHeight="36px"
                    fontSize="32px"
                    mt="20px"
                    mb="15px">
                    Phone Number
                </Heading>

                <InputGroup
                    overflow="hidden"
                    bg="white"
                    border="2px solid #1b3b5f"
                    borderRadius="8px"
                    h="48px"
                    mt="15px">
                    <InputLeftElement pointerEvents="none">{search}</InputLeftElement>
                    <Input
                        type="text"
                        placeholder="type phone"
                        h="full"
                        name="phone"
                        inputMode="search"
                        border="none"
                        value={userInfo.phone}
                        onChange={(e) => handlePhoneChange(e)}
                        onKeyUp={(e) => addPhoneInfo(e)}
                    />
                </InputGroup>

                <Heading
                    color="#090A0A"
                    w="80%"
                    lineHeight="36px"
                    fontSize="32px"
                    mt="20px"
                    mb="15px">
                    Delivery Address
                </Heading>
                <Text fontSize="16px" color="#090A0A">
                    Enter your location to find them.
                </Text>

                <InputGroup
                    overflow="hidden"
                    bg="white"
                    border="2px solid #1b3b5f"
                    borderRadius="8px"
                    h="48px"
                    mt="15px">
                    <InputLeftElement pointerEvents="none">{search}</InputLeftElement>
                    <Input
                        type="text"
                        placeholder="type address"
                        h="full"
                        name="address"
                        inputMode="search"
                        border="none"
                        disabled={checked}
                        value={address.street}
                        onChange={(e) => handleLocationChange(e)}
                        onKeyUp={(e) => addLocationInfo(e)}
                    />
                </InputGroup>

                <HStack align={'center'} justify="space-between" py="12px">
                    <Heading
                        color="#090A0A"
                        w="85%"
                        lineHeight="16px"
                        fontSize="16px"
                        mt="20px"
                        mb="15px">
                        Pick Up from Fazsion
                    </Heading>
                    <Switch
                        colorScheme="facebook"
                        size="lg"
                        isChecked={checked}
                        value={checked}
                        onChange={(e) => handleChange(e)}
                    />
                </HStack>
                <div>{}</div>
                <VStack align="start">
                    {typeof add.street[0] !== 'undefined' ? (
                        <HStack align={'center'} justify="space-between" gap="10px" mb="1rem">
                            <p>{location}</p>
                            <Box>
                                <Text fontSize="16px" color="#090A0A" lineHeight="20px">
                                    {add?.street}
                                </Text>
                                <Text fontSize="14px" color="#72777A" lineHeight="16px">
                                    {add.city}
                                </Text>
                            </Box>
                        </HStack>
                    ) : (
                        <></>
                    )}
                </VStack>
                <VStack align="start">
                    {typeof add.street[0] !== 'undefined' ? (
                        <HStack align={'center'} justify="space-between" gap="10px" mb="1rem">
                            {userIcon}
                            <Box>
                                <Text fontSize="16px" color="#090A0A" lineHeight="20px">
                                    {add?.firstname}
                                </Text>
                                <Text fontSize="16px" color="#090A0A" lineHeight="20px">
                                    {add?.telephone}
                                </Text>
                            </Box>
                        </HStack>
                    ) : (
                        <></>
                    )}
                </VStack>
                <VStack align="start">
                    {typeof add.street[0] !== 'undefined' ? (
                        <HStack
                            align={'center'}
                            justify="space-between"
                            gap="10px"
                            mb="1rem"
                            w="100%">
                            <Box w="100%">
                                <Heading
                                    color="#090A0A"
                                    w="85%"
                                    lineHeight="16px"
                                    fontSize="16px"
                                    mt="20px"
                                    mb="15px">
                                    Summary
                                </Heading>
                                <Flex
                                    color="white"
                                    w="100%"
                                    direction="row"
                                    justify="space-between">
                                    <Text fontSize="16px" color="#090A0A" lineHeight="20px">
                                        Total item costs
                                    </Text>
                                    <Text
                                        fontSize="16px"
                                        color="#090A0A"
                                        lineHeight="20px"
                                        marginBottom="8px">
                                        {new Intl.NumberFormat('en-NG', {
                                            style: 'currency',
                                            currency: 'NGN',
                                        }).format(total)}
                                    </Text>
                                </Flex>
                                {/* </div> */}
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        width: '100%',
                                        justifyContent: 'space-between',
                                    }}>
                                    <Text fontSize="16px" color="#090A0A" lineHeight="20px">
                                        Total shipping cost
                                    </Text>
                                    <Text fontSize="16px" color="#090A0A" lineHeight="20px">
                                        {new Intl.NumberFormat('en-NG', {
                                            style: 'currency',
                                            currency: 'NGN',
                                        }).format(0)}
                                    </Text>
                                </div>
                                <br />
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        width: '100%',
                                        justifyContent: 'space-between',
                                        borderTop: '.2px solid #EFEFEF',
                                        paddingTop: '15px',
                                    }}>
                                    <Text fontSize="16px" color="#090A0A" lineHeight="20px">
                                        Total
                                    </Text>
                                    <Text fontSize="16px" color="#090A0A" lineHeight="20px">
                                        {new Intl.NumberFormat('en-NG', {
                                            style: 'currency',
                                            currency: 'NGN',
                                        }).format(total)}
                                    </Text>
                                </div>
                            </Box>
                        </HStack>
                    ) : (
                        <></>
                    )}
                </VStack>
                <Button
                    w={{ base: 'full', lg: '60%' }}
                    color="#F5F5F5"
                    bg="#1b3b5f"
                    fontWeight="400"
                    borderRadius="48px"
                    outline="none"
                    h="48px"
                    mt={{ lg: '5rem', base: '0' }}
                    position={{ base: 'absolute', lg: 'relative' }}
                    bottom="0"
                    onClick={() => {
                        openModal();
                        setOrderDetails();
                    }}>
                    Proceed to Complete Order
                </Button>
            </Box>
            <DeliveryModal
                isModalOpen={isModalOpen}
                closeModal={closeModal}
                setIsModalOpen={setIsModalOpen}
                id={quoteId}
            />
        </OrderSection>
    );
};

export default Delivery;
